export const SEVERITY_LABEL = 'Severity'
export const STATUS_LABEL = 'Status'
export const DESCRIPTION_LABEL = 'Description'
export const DEFAULT_EXPORT_DOCUMENT_TITLE = 'Signal Export'
export const EXPORT_LABEL = 'Export'

export const CONTROL_LABEL = 'Control'
export const SIGNAL_DETAILS_LABEL = 'Signal details'
export const ALERT_DETAILS_LABEL = 'Alert details'
export const DETECTION_TIME_LABEL = 'Detection time'
export const ALERT_RULE_LABEL = 'Alert rule'
export const ACTIVITY_LABEL = 'Activity'
export const EVIDENCE_LABEL = 'Evidence'
export const MITIGATION_STEPS_LABEL = 'Mitigation steps'
export const FALSE_POSITIVE_LABEL = 'False positive'
export const SIGNAL_FLAGGED_SUCCESS_LABEL = 'Signal flagged successfully'
export const SIGNAL_FLAG_FALSE_POSITIVE_FAILED_LABEL =
  'Failed to flag this signal as false positive'

export const FALSE_POSITIVE_MODAL_TEXT = {
  TITLE: 'Flag alert as false positive',
  SUBTITLE:
    'The signal will be hidden from your system and Lema’s team will be notified via a support ticket',
  PRIMARY_BUTTON: 'Flag',
  REASON_LABEL: 'Reason',
  REASON_PLACEHOLDER: 'Help us improve (optional)',
} as const
